import React from "react";

export const getPaidStatusTitle = (statusId) => {
  let statusTitle;
  switch (statusId) {
    case 1:
      statusTitle = "Unpaid";
      break;
    case 2:
      statusTitle = "Partly Paid";
      break;
    case 3:
      statusTitle = "Paid";
      break;
    case 4:
      statusTitle = "PaidVoid";
      break;
    case 5:
      statusTitle = "PaidComp";
      break;
    case 6:
      statusTitle = "PaidMember";
      break;
    default:
      statusTitle = "-";
  }
  return statusTitle;
};

const GetPaidStatus = ({ row }) => {
  return <div>{getPaidStatusTitle(row?.paidStatusId)}</div>;
};

export default GetPaidStatus;
